module.exports = __webpack_public_path__ + "static/66invgde-aef4ecc6a47195f5b434636c8d96a7e8.gif";